import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import { CSPProvider } from '@base-ui/react/csp-provider'
import { LocalizationProvider } from '@/i18n'
import { ThemeProvider } from '@/theme'
import OrcKnowledgeModalProvider from '@/components/OrcKnowledgeModalProvider'
import App from './App'
import { initSentry } from './sentry'
import { installMaintenanceFetchGuard } from './maintenance'
import './index.css'

installMaintenanceFetchGuard()
initSentry()

function bootstrapApplication() {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <CSPProvider disableStyleElements>
        <BrowserRouter>
          <ThemeProvider defaultTheme="auto">
            <LocalizationProvider defaultLanguage="ru">
              <OrcKnowledgeModalProvider>
                <App />
              </OrcKnowledgeModalProvider>
            </LocalizationProvider>
          </ThemeProvider>
        </BrowserRouter>
      </CSPProvider>
    </React.StrictMode>,
  )
}

bootstrapApplication()
